export default "__VITE_ASSET__BZ0TZkqa__"